import { FC, ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import styles from './createProjectModalHeader.module.scss'

interface CreateProjectModalHeaderProps {
  centerTitle?: boolean
  currentStep: number
  hideSteps?: boolean
  leftActionAriaLabel?: string
  leftActionIcon?: ReactNode
  onClose: () => void
  onLeftAction?: () => void
  title: string
  totalSteps?: number
}

export const CreateProjectModalHeader: FC<CreateProjectModalHeaderProps> = ({
  currentStep,
  centerTitle = false,
  leftActionAriaLabel,
  leftActionIcon,
  onLeftAction,
  onClose,
  title,
  totalSteps = 3,
  hideSteps = false,
}) => {
  return (
    <div
      className={`${styles.headerWrapper} ${hideSteps ? styles.headerWrapperCompact : ''}`}
    >
      <div
        className={`${styles.headerRow} ${
          centerTitle ? styles.headerRowCentered : ''
        }`}
      >
        {centerTitle ? (
          <>
            <button
              aria-label={leftActionAriaLabel || 'Back'}
              className={styles.sideActionButton}
              onClick={onLeftAction}
              type="button"
            >
              {leftActionIcon || null}
            </button>

            <h1 className={`${styles.modalTitle} ${styles.modalTitleCentered}`}>
              {title}
            </h1>

            <button
              aria-label="Close modal"
              className={styles.closeButton}
              onClick={onClose}
              type="button"
            >
              <FontAwesomeIcon className={styles.closeIcon} icon={faTimes} />
            </button>
          </>
        ) : (
          <>
            <h1 className={styles.modalTitle}>{title}</h1>

            <button
              aria-label="Close modal"
              className={styles.closeButton}
              onClick={onClose}
              type="button"
            >
              <FontAwesomeIcon className={styles.closeIcon} icon={faTimes} />
            </button>
          </>
        )}
      </div>

      {!hideSteps && (
        <div className={styles.stepsMetric}>
          {Array.from({ length: totalSteps }).map((_, idx) => (
            <div
              className={`${styles.stepItem} ${
                idx < currentStep ? styles.completed : ''
              }`}
              key={idx}
            />
          ))}
        </div>
      )}
    </div>
  )
}
